module.exports = __webpack_public_path__ + "static/media/big_resto.9b81fa58.jpg";